import {useTranslation} from 'react-i18next';
import MoneyBagIls from '../../images/newDesign/managers/money_bag_ils.svg';
import MoneyBagMxn from '../../images/newDesign/managers/money_bag_mxn.svg';
import MoneyBagGbp from '../../images/newDesign/managers/money_bag_gbp.svg';
import MoneyBagEur from '../../images/newDesign/managers/money_bag_eur.svg'
import ChequeIls from '../../images/newDesign/managers/cheque_ils.svg';
import ChequeMxn from '../../images/newDesign/managers/cheque_mxn.svg';
import ChequeGbp from '../../images/newDesign/managers/cheque_gbp.svg';
import ChequeEur from '../../images/newDesign/managers/cheque_eur.svg';
import timeSavedIcon from '../../images/managers/time-saved.png';
import DebtIcon from '../../images/managers/debts-accumulated.png';
import TotalDebtIcon from '../../images/managers/total-debts-icon.png';
import BllinkUtils from '../../common/utils/utils';
import {ProfileStatsStyled} from './buildingManagerProfile.styled';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";

const Money = BllinkUtils.Money;
const StringUtils = BllinkUtils.Strings;

export default function ProfileStats({dashboardData, buildingData, isMcDashboard, className}) {
    const {t} = useTranslation();

    const hoursSaved = Money.roundNumber(dashboardData.hoursSaved,0 );
    const {paymentsThisMonth, totalOneTimeDebts, totalMonthsDebts, totalForManualDeposit} = dashboardData;
    const currencyFromServer = (buildingData && buildingData.currency) || paymentsThisMonth.currency || totalForManualDeposit.currency;
    const isValid = currencyFromServer;
    if (!isValid) return null;
    const currency = t(`currency.${currencyFromServer}`) ;
    const paymentsThisMonthsValue = StringUtils.numberWithCommas(Money.roundNumber(paymentsThisMonth.value, 0));
    const totalOneTimeDebtsValue = StringUtils.numberWithCommas(Money.roundNumber(totalOneTimeDebts.value, 0));
    const totalMonthsDebtsValue = StringUtils.numberWithCommas(Money.roundNumber(totalMonthsDebts.value, 0));
    const totalForManualDepositValue = totalForManualDeposit && StringUtils.numberWithCommas(Money.roundNumber(totalForManualDeposit.value, 0));

    const currencyImage = () => {
        if (currency === t('currency.ils')) {
            return {
                bag: MoneyBagIls,
                cheque: ChequeIls
            }
        } else if (currency === t('currency.mxn')) {
            return {
                bag: MoneyBagMxn,
                cheque: ChequeMxn
            }
        } else if (currency === t('currency.gbp')) {
            return {
                bag: MoneyBagGbp,
                cheque: ChequeGbp
            }
        } else if (currency === t('currency.eur')) {
            return {
                bag: MoneyBagEur,
                cheque: ChequeEur
            }
        }
    }

    function InfoTooltip({ children, i18nKey }) {
        return (
            <OverlayTrigger placement="top" overlay={props => <Tooltip {...props}>{t(i18nKey)}</Tooltip>}>
                {children}
            </OverlayTrigger>
        );
    }

    return (
        <ProfileStatsStyled className={`dashboard_n_sec widgets-align ${className}`} turnCurrency={StringUtils.checkReverseCurrencyOrder(currency, t)}>
            <InfoTooltip i18nKey="buildings.total_payments_this_month_tooltip">
                <div className="dash_1">
                    <div className="dash_1-image">
                        <img src={currencyImage().bag} alt="total payments"/>
                    </div>
                    <p>{t('buildings.total_payments_this_month')}</p>
                    <h3 className='currency_header'><span>{paymentsThisMonthsValue}</span><span>{currency}</span></h3>
                    {/*
                        NOTE: this value do not match monthly table total in credit card value, the relationship is next
                              dashboard_total === monthly_card_total - last_month_tourist + this_month_tourist + refunds
                              monthly_card_total = payment_total + last_month_tourist - refunds
                              dashboard_total = payment_total + this_month_tourist
                    */}
                </div>
            </InfoTooltip>
            { isMcDashboard ? (
                <InfoTooltip i18nKey="buildings.total_manual_deposit_tooltip">
                    <div className="dash_1">
                        <div className="dash_1-image" style={{width: '45px'}}>
                            <img src={currencyImage().cheque} alt={t('buildings.total_manual_deposit')} />
                        </div>
                        <p>{t('buildings.total_manual_deposit')}</p>
                        <h3 className='currency_header'><span>{totalForManualDepositValue}</span><span>{currency}</span></h3>
                    </div>
                </InfoTooltip>
            ) : (
                <InfoTooltip i18nKey="buildings.hours_saved_tooltip">
                    <div className="dash_1">
                        <div className="dash_1-image">
                            <img src={timeSavedIcon} alt={t('buildings.hours_saved')}/>
                        </div>
                        <p>{t('buildings.hours_saved')}</p>
                        <h3>{hoursSaved} {t('buildings.hours')} </h3>
                    </div>
                </InfoTooltip>
            ) }
            <InfoTooltip i18nKey="buildings.total_debts_for_one_time_tooltip">
                <div className="dash_1 widget2-padding">
                    <div className="dash_1-image">
                        <img src={DebtIcon} alt={t('buildings.total_debts_for_one_time')}/>
                    </div>
                    <p>{t('buildings.total_debts_for_one_time')}</p>
                    <h3 className='currency_header' id="he_content"><span>{totalOneTimeDebtsValue}</span><span>{currency}</span></h3>
                </div>
            </InfoTooltip>
            <InfoTooltip i18nKey="buildings.total_debts_for_monthly_tooltip">
                <div className="dash_1">
                    <div className="dash_1-image">
                        <img src={TotalDebtIcon} alt={t('buildings.total_debts_for_monthly')}/>
                    </div>
                    <p>{t('buildings.total_debts_for_monthly')}</p>
                    <h3 className='currency_header' id="he_content"><span>{totalMonthsDebtsValue}</span><span>{currency}</span></h3>
                </div>
            </InfoTooltip>
        </ProfileStatsStyled>
    );
}
